<div class="modol_comp">
    <div class="modal-header pb-0 pt-0 d-flex">
        <button class="button-close" mat-button [mat-dialog-close]="false">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                    d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
            </svg>
        </button>
    </div>
    <div class="modal-body pt-0">
        <h2> {{'Add Package'}}</h2>

        <form class="" [formGroup]="packageFrom">
            <div class="row mt-0">

                <div class="form-group col-md-12">
                    <!-- Package Name -->
                    <label class="">Package Name</label>
                    <input class="form-control mt-3" formControlName="packageName" type="text"
                        placeholder="Enter package name"
                        [ngClass]="{ 'is-invalid': submitted && f['packageName'].errors}">
                    <div *ngIf="submitted && f['packageName'].errors" class="invalid-feedback" style="display: block;">
                        <ng-container *ngIf="f['packageName'].errors['required']">
                            {{'Package name is required.'}}
                        </ng-container>
                    </div>
                </div>

                <!-- Package Pricing -->
                <div class="form-group col-md-12">
                    <label class="">Package Pricing</label>
                    <input class="form-control mt-3" formControlName="amount" type="number" placeholder="Enter Amount"
                        (keydown.space)="$event.preventDefault()"
                        (keypress)="validationService.numberWithDecimal($event)" (blur)="setTodecimal()"
                        [ngClass]="{ 'is-invalid': submitted && f['amount'].errors}">
                    <div *ngIf="submitted && f['amount'].errors" class="invalid-feedback" style="display: block;">
                        <ng-container *ngIf="f['amount'].errors['required']">
                            {{'Amount is required.'}}
                        </ng-container>
                        <ng-container *ngIf="f['amount'].errors['min']">
                            {{'Amount cannot be smaller than 0.'}}
                        </ng-container>
                    </div>
                </div>

                <!-- Truck Pricing -->
                <div class="form-group col-md-12">
                    <label class="">Truck Pricing</label>
                    <input class="form-control mt-3" formControlName="truckAmount" type="number"
                        placeholder="Enter Truck Pricing" (keydown.space)="$event.preventDefault()"
                        (keypress)="validationService.numberWithDecimal($event)" (blur)="setTodecimal()"
                        [ngClass]="{ 'is-invalid': submitted && f['truckAmount'].errors}">
                    <div *ngIf="submitted && f['truckAmount'].errors" class="invalid-feedback" style="display: block;">
                        <ng-container *ngIf="f['truckAmount'].errors['required']">
                            {{'Amount is required.'}}
                        </ng-container>
                        <ng-container *ngIf="f['truckAmount'].errors['min']">
                            {{'Amount cannot be smaller than 0.'}}
                        </ng-container>
                    </div>
                </div>

                <!-- AI Routing Pricing -->
                <div class="form-group col-md-12">
                    <label class="">AI Routing Pricing</label>
                    <input class="form-control mt-3" formControlName="aiRoutingAmount" type="number"
                        placeholder="Enter AI Routing Pricing" (keydown.space)="$event.preventDefault()"
                        (keypress)="validationService.numberWithDecimal($event)" (blur)="setTodecimal()"
                        [ngClass]="{ 'is-invalid': submitted && f['aiRoutingAmount'].errors}">
                    <div *ngIf="submitted && f['aiRoutingAmount'].errors" class="invalid-feedback"
                        style="display: block;">
                        <ng-container *ngIf="f['aiRoutingAmount'].errors['required']">
                            {{'Amount is required.'}}
                        </ng-container>
                        <ng-container *ngIf="f['aiRoutingAmount'].errors['min']">
                            {{'Amount cannot be smaller than 0.'}}
                        </ng-container>
                    </div>
                </div>

                <!-- Email Marketing Pricing -->
                <div class="form-group col-md-12">
                    <label class="">Email Marketing Pricing</label>
                    <input class="form-control mt-3" formControlName="emailMarketAmount" type="number"
                        placeholder="Enter Email Marketing Pricing" (keydown.space)="$event.preventDefault()"
                        (keypress)="validationService.numberWithDecimal($event)" (blur)="setTodecimal()"
                        [ngClass]="{ 'is-invalid': submitted && f['emailMarketAmount'].errors}">
                    <div *ngIf="submitted && f['emailMarketAmount'].errors" class="invalid-feedback"
                        style="display: block;">
                        <ng-container *ngIf="f['emailMarketAmount'].errors['required']">
                            {{'Amount is required.'}}
                        </ng-container>
                        <ng-container *ngIf="f['emailMarketAmount'].errors['min']">
                            {{'Amount cannot be smaller than 0.'}}
                        </ng-container>
                    </div>
                </div>

                <!-- Notifications Pricing -->
                <div class="form-group col-md-12">
                    <label class="">Notifications Pricing</label>
                    <input class="form-control mt-3" formControlName="notificationsAmount" type="number"
                        placeholder="Enter Notifications Pricing" (keydown.space)="$event.preventDefault()"
                        (keypress)="validationService.numberWithDecimal($event)" (blur)="setTodecimal()"
                        [ngClass]="{ 'is-invalid': submitted && f['notificationsAmount'].errors}">
                    <div *ngIf="submitted && f['notificationsAmount'].errors" class="invalid-feedback"
                        style="display: block;">
                        <ng-container *ngIf="f['notificationsAmount'].errors['required']">
                            {{'Amount is required.'}}
                        </ng-container>
                        <ng-container *ngIf="f['notificationsAmount'].errors['min']">
                            {{'Amount cannot be smaller than 0.'}}
                        </ng-container>
                    </div>
                </div>

                <!-- AI Phone Agent Pricing -->
                <div class="form-group col-md-12">
                    <label class="">AI Phone Agent Pricing</label>
                    <input class="form-control mt-3" formControlName="aiAgentAmount" type="number"
                        placeholder="Enter AI Phone Agent Pricing" (keydown.space)="$event.preventDefault()"
                        (keypress)="validationService.numberWithDecimal($event)" (blur)="setTodecimal()"
                        [ngClass]="{ 'is-invalid': submitted && f['aiAgentAmount'].errors}">
                    <div *ngIf="submitted && f['aiAgentAmount'].errors" class="invalid-feedback"
                        style="display: block;">
                        <ng-container *ngIf="f['aiAgentAmount'].errors['required']">
                            {{'Amount is required.'}}
                        </ng-container>
                        <ng-container *ngIf="f['aiAgentAmount'].errors['min']">
                            {{'Amount cannot be smaller than 0.'}}
                        </ng-container>
                    </div>
                </div>

                <!-- Duration -->
                <div class="form-group col-md-12">
                    <label class="">Duration</label>
                    <mat-select class="form-control mt-3" formControlName="duration"
                        [ngClass]="{ 'is-invalid': submitted && f['duration'].errors}" placeholder="Select duration">
                        <mat-option *ngFor="let duation of durationArray"
                            [value]="duation?.value">{{duation?.value}}</mat-option>
                    </mat-select>
                    <div *ngIf=" submitted && f['duration'].errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['duration'].errors['required']"> Duration is required. </div>
                    </div>
                </div>

            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn cancel" [mat-dialog-close]="false">Cancel</button>
        <!-- <button type="submit" class="btn delete-btn" *ngIf="data.type==2">Delete</button> -->
        <button type="submit" class="btn delete" (click)="addPackage()">{{'Pay'}}</button>
    </div>

</div>